import {
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChild,
} from '@angular/core';
import { StepperOrientation, MatStepper } from '@angular/material/stepper';
import { StepperStepDirective } from './stepper-step.directive';

type StepperChangeEvent = { selectedIndex: number };

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
})
export class StepperComponent {
  @ContentChildren(StepperStepDirective)
  stepTemplates!: QueryList<StepperStepDirective>;

  @ViewChild('stepper', { static: true }) stepper?: MatStepper;

  @Input() orientation: StepperOrientation = 'horizontal';
  @Input() linear = true;
  @Input() labelPosition: 'bottom' | 'end' = 'bottom';
  @Input() editIcon = 'task_alt';
  @Input() maxWidth = '1200px';
  @Output() selectionChange = new EventEmitter<StepperChangeEvent>();

  get steps(): StepperStepDirective[] {
    return this.stepTemplates?.toArray() ?? [];
  }

  trackByIndex(index: number): number {
    return index;
  }
}
